

import React, { useState, useEffect, useRef } from "react";
import {
  Modal,

  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton, Autocomplete, Grid, Typography, Select, MenuItem, InputLabel, FormControl, Chip, OutlinedInput, Box, Tooltip
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import { v4 as uuidv4 } from "uuid"; // Import UUID
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import ProductSelectionTable from 'components/ProductSelectionTable';
import { useAuth } from '../../auth/Auth';
import { usePermission } from '../../auth/usePermission';
import InfoIcon from '@mui/icons-material/Info';
import Popper from '@mui/material/Popper'; // Add this import at the top of your file
import { InputAdornment } from "@mui/material";
import { useParams, useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import colors from "assets/theme/base/colors";
import { DropdownMenu } from "@radix-ui/react-dropdown-menu";
import { currencies } from 'utils/CurrencyList';
import CustomFieldsSection from 'components/CustomFields/CustomFieldsSection';
import { useCurrency } from '../../context/CurrencyContext';
import axios from "axios"; // Add this for exchange rate API
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'; // Add this for conversion icon
import { frontendLogger } from '../../utils/logger';
import {
  VEHICLE_NUMBER_HELPER,
  VEHICLE_NUMBER_PATTERN,
  toDateOnlyString,
  validateOrderTransportAndDates,
} from 'utils/orderValidation';


function OrderModal({
  isOpen,
  onClose,
  onSave,
  dealId,
  dealName,
  onProductsChange,
  user,
  preselectedAccount
}) {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [orderStatus, setOrderStatus] = useState('Draft');
  const [totalAmount, setTotalAmount] = useState(0);
  const [tax, setTax] = useState(0);
  const [shippingMethod, setShippingMethod] = useState('');
  const [shippingAddress, setShippingAddress] = useState('');
  const [shippingInstruction, setShippingInstruction] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [notes, setNotes] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [productList, setProductList] = useState([]);
  const { axiosInstance } = useAuth();
  const { isSupportUser } = usePermission('orders');
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [subtotal, setSubtotal] = useState(0); // Define missing state
  const [grandTotal, setGrandTotal] = useState(0); // Define missing state
  const [taxSummary, setTaxSummary] = useState({}); // Define missing state
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [poNumber, setPoNumber] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  // Add these to your suggestions state or create new state
  const [dealSuggestions, setDealSuggestions] = useState([]);
  const [quotationSuggestions, setQuotationSuggestions] = useState([]);
  const [contactSuggestions, setContactSuggestions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accountSuggestions, setAccountSuggestions] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [users, setUsers] = useState([]);
  const [transid, setTransid] = useState('');
  const [transname, setTransname] = useState('');
  const [transmode, setTransmode] = useState('');
  const [vehno, setVehno] = useState('');
  const [vehtype, setvehtype] = useState('');
  const [transdocno, setTransdocno] = useState('');
  const [transdocdate, setTransdocdate] = useState('');
  const { formatCurrency, currency: systemCurrency, getCurrencyLabel, availableCurrencies } = useCurrency();
  const initialState = {
    selectedProducts: [],
    orderStatus: 'Draft',
    totalAmount: 0,
    tax: 0,
    shippingMethod: '',
    shippingAddress: '',
    shippingInstruction: '',
    billingAddress: '',
    paymentMethods: [],
    currency: systemCurrency,
    notes: '',
    deliveryDate: '',
    selectedAgent: null,
    subtotal: 0,
    grandTotal: 0,
    taxSummary: {},
    selectedDeal: null,
    selectedQuotation: null,
    selectedContact: null,
    selectedAccount: null,
    poNumber: '',
    transid: '',
    transname: '',
    transmode: '',
    transdocno: '',
    // transdocdate: '',
    vehno: '',
    vehtype: '',
    rows: [{
      id: uuidv4(),
      productName: "",
      price: 0,
      tax: 0,
      quantity: 0,
      discount_percentage: 0,
      discountPrice: 0,
      totalPrice: 0,
      productCurrency: null, // Add this
      originalPrice: 0, // Add this
      convertedCurrency: false, // Add this
      exchangeRate: 1, // Add this
    }],
    errors: {
      account: false,
      contact: false,
      delivery_date: '',
      vehno: '',
    }
  };
  const [customFields, setCustomFields] = useState([]);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const customFieldsRef = useRef(null);
  const [currency, setCurrency] = useState(systemCurrency); // Change from null to systemCurrency
  // Add these new states for currency conversion
  const [exchangeRates, setExchangeRates] = useState({});
  const [showCurrencyConversionDialog, setShowCurrencyConversionDialog] = useState(false);
  const [currentConversion, setCurrentConversion] = useState({
    rowId: null,
    productId: null,
    productName: '',
    sourceCurrency: '',
    targetCurrency: '',
    originalPrice: 0,
    convertedPrice: 0,
    exchangeRate: 1,
  });
  const [isLoadingRates, setIsLoadingRates] = useState(false);


  const resetForm = () => {
    setSelectedProducts(initialState.selectedProducts);
    setOrderStatus(initialState.orderStatus);
    setTotalAmount(initialState.totalAmount);
    setTax(initialState.tax);
    setShippingMethod(initialState.shippingMethod);
    setShippingAddress(initialState.shippingAddress);
    setShippingInstruction(initialState.shippingInstruction);
    setBillingAddress(initialState.billingAddress);
    setPaymentMethods(initialState.paymentMethods);
    setNotes(initialState.notes);
    setDeliveryDate(initialState.deliveryDate);
    setSelectedAgent(initialState.selectedAgent);
    setSubtotal(initialState.subtotal);
    setGrandTotal(initialState.grandTotal);
    setTaxSummary(initialState.taxSummary);
    setSelectedDeal(initialState.selectedDeal);
    setSelectedQuotation(initialState.selectedQuotation);
    setSelectedContact(initialState.selectedContact);
    setSelectedAccount(initialState.selectedAccount);
    setPoNumber(initialState.poNumber);
    setCurrency(systemCurrency); // Change from 'INR' to systemCurrency
    setRows(initialState.rows);
    setErrors(initialState.errors);
    setLoading(false); // Reset loading state
    setCustomFieldValues({}); // Reset custom field values
    setTransid(initialState.transid);
    setTransname(initialState.transname);
    setTransmode(initialState.transmode);
    setTransdocno(initialState.transdocno);
    setVehno(initialState.vehno);
    setvehtype(initialState.vehtype);
  };

  const currencyOptions = currencies;

  // const [dealInput, setDealInput] = useState('Quote_1');
  const [rows, setRows] = useState([
    {
      id: uuidv4(),
      productName: "",
      price: 0,
      tax: 0,
      quantity: 0,
      discount_percentage: 0,
      discountPrice: 0,
      totalPrice: 0,
    },
  ]);
  const [suggestions, setSuggestions] = useState({
    locations: [],
    categories: [],
    brands: [],
    manufacturers: [],
    names: [],
  });

  // Add these state variables at the top of your component
  const [errors, setErrors] = useState({
    account: false,
    contact: false,
    delivery_date: '',
    vehno: '',
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  // Add this validation function
  const validateForm = () => {
    const orderDateToday = toDateOnlyString(new Date());
    const fieldValidation = validateOrderTransportAndDates({
      deliveryDate,
      orderDate: orderDateToday,
      vehno,
      transmode,
    });
    const newErrors = {
      account: !selectedAccount,
      contact: !selectedContact,
      delivery_date: fieldValidation.errors.delivery_date || '',
      vehno: fieldValidation.errors.vehno || '',
    };

    setErrors(newErrors);
    return (
      !newErrors.account &&
      !newErrors.contact &&
      !newErrors.delivery_date &&
      !newErrors.vehno
    );
  };
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axiosInstance.get('/users/');
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUsers();
  }, []);

  // console.log(`User:`, user);

  useEffect(() => {
    if (user) {
      const currentUserAsAgent = {
        id: user.id,
        username: user.username
      };
      setSelectedAgent(currentUserAsAgent);
    }
  }, [user]);

  // Consolidated useEffect for preselectedAccount and selectedAccount
  useEffect(() => {
    if (isOpen) {
      if (preselectedAccount) {
        setSelectedAccount(preselectedAccount);
        const { shippingAddress, billingAddress } = combineAddress(preselectedAccount);
        setShippingAddress(shippingAddress);
        setBillingAddress(billingAddress);

        const accountCurrency = availableCurrencies.find(c => c.value === preselectedAccount.currency) ||
          availableCurrencies.find(c => c.value === systemCurrency);
        setCurrency(accountCurrency ? accountCurrency.value : systemCurrency);
      }

      const fetchAccountDetails = async () => {
        if (selectedAccount?.id) {
          try {
            const response = await axiosInstance.get(`/accounts/${selectedAccount.id}`);
            const accountDetails = response.data;
            const { shippingAddress, billingAddress } = combineAddress(accountDetails);
            setShippingAddress(shippingAddress);
            setBillingAddress(billingAddress);

            const validCurrency = availableCurrencies.find(c => c.value === accountDetails.currency) ||
              availableCurrencies.find(c => c.value === systemCurrency);
            setCurrency(validCurrency ? validCurrency.value : systemCurrency);

            const contactsResponse = await axiosInstance.get(`/contacts/?account_id=${selectedAccount.id}`);
            setContactSuggestions(contactsResponse.data.map(contact => ({
              id: contact.id,
              name: `${contact.first_name} ${contact.last_name}`.trim()
            })));
          } catch (error) {
            console.error("Error fetching account details:", error);
          }
        } else if (!preselectedAccount) {
          setShippingAddress('');
          setBillingAddress('');
          setCurrency(systemCurrency);
          setContactSuggestions([]);
        }
      };

      fetchAccountDetails();
    }
  }, [isOpen, preselectedAccount, selectedAccount, axiosInstance]);

  const combineAddress = (account) => {
    const shippingParts = [
      account?.shipping_address || '',
      account?.shipping_city || '',
      account?.shipping_postal_code || '',
      account?.shipping_state || '',
      account?.shipping_country || '',

    ].filter(part => part).join(', ');

    const billingParts = [
      account?.billing_address || '',
      account?.billing_city || '',
      account?.billing_postal_code || '',
      account?.billing_state || '',
      account?.billing_country || '',

    ].filter(part => part).join(', ');

    return { shippingAddress: shippingParts || '', billingAddress: billingParts || '' };
  };

  useEffect(() => {
    const fetchSuggestions = async () => {
      try {
        // First fetch accounts since they're independent
        const accountsResponse = await axiosInstance.get("/accounts/");
        setAccountSuggestions(
          accountsResponse.data.map(account => ({
            id: account.id,
            name: account.name
          }))
        );

        // If there's a selected account, fetch related contacts and deals
        if (selectedAccount?.id) {
          const [dealsResponse, quotationsResponse, contactsResponse] = await Promise.all([
            axiosInstance.get(`/accounts/deals/${selectedAccount.id}`),
            axiosInstance.get(`/quotations/?account_id=${selectedAccount.id}`),
            axiosInstance.get(`/contacts/?account_id=${selectedAccount.id}`),
          ]);

          setDealSuggestions(
            dealsResponse.data.map(deal => ({
              id: deal.id,
              name: deal.name || deal.title
            }))
          );

          setQuotationSuggestions(
            quotationsResponse.data.map(quotation => ({
              id: quotation.id,
              name: quotation.quote_name || quotation.title
            }))
          );

          setContactSuggestions(
            contactsResponse.data.map(contact => ({
              id: contact.id,
              name: `${contact.first_name} ${contact.last_name}`.trim()
            }))
          );
        } else {
          // Clear related data if no account is selected
          setDealSuggestions([]);
          setQuotationSuggestions([]);
          setContactSuggestions([]);
        }

      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    };

    fetchSuggestions();
  }, [selectedAccount]); // Add selectedAccount to dependency array

  const handleSaveOrder = async (data) => {
    if (isSupportUser) {
      setSnackbar({
        open: true,
        message: 'Support users are not allowed to create orders.',
        severity: 'error',
      });
      return; // Exit the function early
    }

    setLoading(true); // Start showing the spinner

    if (!validateForm()) {
      const orderDateToday = toDateOnlyString(new Date());
      const fieldValidation = validateOrderTransportAndDates({
        deliveryDate,
        orderDate: orderDateToday,
        vehno,
        transmode,
      });
      setSnackbar({
        open: true,
        message:
          fieldValidation.errors.delivery_date ||
          fieldValidation.errors.vehno ||
          'Please fill in all required fields (Account and Contact)',
        severity: 'error',
      });
      setLoading(false); // Stop the loader
      return;
    }

    // Validation to ensure at least one valid product is added
    const hasValidProduct = rows.some(row => row.productId && row.productName && row.quantity > 0);

    if (!hasValidProduct) {
      setSnackbar({
        open: true,
        message: 'Please add at least one valid product before saving the order.',
        severity: 'error',
      });
      setLoading(false); // Stop the loader
      return;
    }

    // Validate custom fields
    const isCustomFieldsValid = customFieldsRef.current?.validateAllFields() ?? true;
    if (!isCustomFieldsValid) {
      setSnackbar({
        open: true,
        message: "Please fill all required custom fields",
        severity: 'error',
      });
      setLoading(false); // Stop the loader
      return;
    }

    // Get current custom field values from state
    const customFieldPayload = customFieldValues;

   const updatedProducts = rows.map(row => {
    const product = productList.find(product => product.id === row.productId);
    return {
      id: row.id,
      product_id: product ? product.id : null,
      product_name: row.productName,
      price: parseFloat(row.price || 0),
      original_price: row.originalPrice || row.price, // Add original price
      original_currency: row.productCurrency || currency, // Add original currency
      exchange_rate: row.exchangeRate || 1, // Add exchange rate
      tax: parseFloat(row.tax || 0),
      quantity: parseInt(row.quantity || 0, 10),
      discount_percentage: parseFloat(row.discount_percentage || 0),
      discounted_price: parseFloat(row.discountPrice || 0),
      total_price: parseFloat(row.totalPrice || 0),
      created_by: user?.id,
      updated_by: user?.id,
      created_by_name: user?.username,
      updated_by_name: user?.username,
    };
  });

    setSelectedProducts(updatedProducts);

    try {
      // Fetch and verify inventory for all products in parallel
      const inventoryChecks = await Promise.all(
        updatedProducts.map(async (item) => {
          const productId = item.product_id;
          const inventoryResponse = await axiosInstance.get(`/inventory/?product_id=${productId}`);
          const inventoryItem = inventoryResponse.data.find(inv => inv.product_id === productId);

          if (!inventoryItem) {
            throw new Error(`Inventory not found for product ${item.product_name} (ID: ${productId})`);
          }

          // Check product type
          const productResponse = await axiosInstance.get(`/products/${productId}`);
          const product = productResponse.data;

          if (product.product_type === 'Physical') {
            if (inventoryItem.quantity < item.quantity) {
              throw new Error(
                `Insufficient inventory for product ${item.product_name}. ` +
                `Available: ${inventoryItem.quantity}, Ordered: ${item.quantity}`
              );
            }
          }

          return {
            inventoryItem,
            orderItem: item,
          };
        })
      );

      const taxSummary = calculateSummary().taxSummary || [];
      const taxSlabs = taxSummary.map(item => item.taxRate || null);
      const taxAmounts = taxSummary.map(item => item.amount || null);

      const orderData = {
        deal_id: selectedDeal?.id,
        deal_name: selectedDeal?.name,
        quotation_id: selectedQuotation?.id,
        contact_id: selectedContact?.id,
        contact_name: selectedContact?.name,
        account_id: selectedAccount?.id,
        account_name: selectedAccount?.name,
        status: orderStatus,
        total_amount: calculateSummary().grandTotal,
        items: updatedProducts,
        subtotal: calculateSummary().subtotal,
        tax_slab_1: taxSlabs[0] || null,
        tax_slab_2: taxSlabs[1] || null,
        tax_slab_3: taxSlabs[2] || null,
        tax_slab_4: taxSlabs[3] || null,
        tax_slab_5: taxSlabs[4] || null,
        tax_slab_amount_1: taxAmounts[0] || null,
        tax_slab_amount_2: taxAmounts[1] || null,
        tax_slab_amount_3: taxAmounts[2] || null,
        tax_slab_amount_4: taxAmounts[3] || null,
        tax_slab_amount_5: taxAmounts[4] || null,
        tax: parseFloat(tax || 0),
        shipping_method: shippingMethod,
        shipping_address: selectedAccount?.shipping_address || shippingAddress,
        billing_address: selectedAccount?.billing_address || billingAddress,
        shipping_instruction: shippingInstruction,
        delivery_date: deliveryDate ? new Date(deliveryDate).toISOString().split('T')[0] : null,
        created_by: user?.id,
        updated_by: user?.id,
        created_by_name: user?.username,
        updated_by_name: user?.username,
        po_number: poNumber,
        currency: currency || selectedAccount?.currency || systemCurrency,
        // Include transport details
        transid: transid,
        transname: transname,
        transmode: transmode,
        vehno: validateOrderTransportAndDates({
          deliveryDate,
          orderDate: toDateOnlyString(new Date()),
          vehno,
          transmode,
        }).normalizedVehno,
        vehtype: vehtype,
        transdocno: transdocno,
        ...customFieldPayload
        // transdocdate: transdocdate ? new Date(transdocdate).toISOString().split('T')[0] : null,
      };

      // Create the order
      const orderResponse = await axiosInstance.post('/orders/', orderData);
      const newOrderId = orderResponse.data.id;

      // --- Log order creation ---
      await frontendLogger.logCreate('Order', {
        id: newOrderId,
        action: 'create',
        account_id: orderData.account_id,
        account_name: orderData.account_name,
        total_amount: orderData.total_amount,
        created_by: user.id,
        created_at: orderResponse.data.created_at || new Date().toISOString()
      });

      const orderItems = updatedProducts.map(item => ({
        order_id: newOrderId,
        product_name: item.product_name,
        product_id: item.product_id,
        quantity: item.quantity,
        unit_price: item.price,
        total_price: item.total_price,
        discount_percentage: item.discount_percentage,
        tax: item.tax,
        discounted_price: item.discounted_price,
      }));

      // Batch create order items
      // await axiosInstance.post('/orders/items', orderItems);
      await Promise.all(orderItems.map(item => axiosInstance.post('/orders/items/', item)));

      // Batch update inventory
      const inventoryUpdates = inventoryChecks.map(async (check) => {
        const { inventoryItem, orderItem } = check;
        const newQuantity = inventoryItem.quantity - orderItem.quantity;

        await axiosInstance.put(`/inventory/${inventoryItem.id}`, {
          ...inventoryItem,
          quantity: newQuantity,
          updated_by: user?.id,
          updated_by_name: user?.username,
        });
      });

      await Promise.all(inventoryUpdates);

      setSnackbar({
        open: true,
        message: 'Order created successfully!',
        severity: 'success',
      });

      setLoading(false); // Reset loading state before navigation
      navigate(`/orders/${newOrderId}`); // Redirect to the new order detail page

    } catch (error) {
      console.error('Error saving order:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      }
      setSnackbar({
        open: true,
        message: `Error saving order: ${error.message}`,
        severity: 'error',
      });
      setLoading(false); // Reset loading state on error
    } finally {
      setLoading(false); // Ensure loading state is reset in all cases
    }
  };


  // Function to fetch exchange rates
const fetchExchangeRate = async (sourceCurrency, targetCurrency) => {
  if (sourceCurrency === targetCurrency) {
    return 1; // Same currency, no conversion needed
  }

  // Check if we already have this rate
  const rateKey = `${sourceCurrency}_${targetCurrency}`;
  if (exchangeRates[rateKey]) {
    return exchangeRates[rateKey];
  }

  setIsLoadingRates(true);
  try {
    const response = await axios.get(`https://open.er-api.com/v6/latest/${sourceCurrency}`);
    const rates = response.data.rates;
    const rate = rates[targetCurrency];
    
    // Store all rates from this response
    const newRates = { ...exchangeRates };
    Object.keys(rates).forEach(curr => {
      newRates[`${sourceCurrency}_${curr}`] = rates[curr];
    });
    setExchangeRates(newRates);
    
    setIsLoadingRates(false);
    return rate;
  } catch (error) {
    console.error('Error fetching exchange rate:', error);
    setIsLoadingRates(false);
    return 1; // Default to 1:1 if API fails
  }
};



  const handleCancel = () => {
    setOpenConfirmationDialog(true);
  };

  const handleConfirmCancel = () => {
    setOpenConfirmationDialog(false);
    setLoading(false); // Reset loading state
    resetForm();
    onClose();
  };


  const handleDialogClose = () => {
    setOpenConfirmationDialog(false);
  };

  const formatIndianNumber = (number) => {
    if (isNaN(number) || number === null || number === undefined) return "0.00";

    const [integerPart, decimalPart] = Number(number).toFixed(2).split(".");
    const lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);

    let formattedNumber = "";
    if (otherDigits) {
      formattedNumber = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThreeDigits;
    } else {
      formattedNumber = lastThreeDigits;
    }

    return `${formattedNumber}.${decimalPart}`; // Always include two decimal places
  };


const handleProductSelect = async (rowId, selectedProduct) => {
  if (!selectedProduct) {
    // If no product is selected, reset the row data
    setRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === rowId) {
          return {
            ...row,
            productName: "",
            productId: null,
            price: 0,
            tax: 0,
            quantity: 0,
            discount_percentage: 0,
            discountPrice: 0,
            totalPrice: 0,
          };
        }
        return row;
      })
    );
    return;
  }

  // Find the product in the productList
  const product = productList.find((p) => p.id === selectedProduct.id);
  
  if (!product) {
    console.error('Product not found:', selectedProduct);
    return;
  }

  // Check if product has a different currency than order
  const productCurrency = product.currency || systemCurrency;
  
  if (productCurrency !== currency) {
    // Currency conversion needed
    try {
      const exchangeRate = await fetchExchangeRate(productCurrency, currency);
      const originalPrice = product.price || 0;
      const convertedPrice = originalPrice * exchangeRate;
      
      // Show currency conversion dialog
      setCurrentConversion({
        rowId,
        productId: product.id,
        productName: product.name,
        sourceCurrency: productCurrency,
        targetCurrency: currency,
        originalPrice,
        convertedPrice,
        exchangeRate,
      });
      
      setShowCurrencyConversionDialog(true);
    } catch (error) {
      console.error('Error during currency conversion:', error);
      // Fall back to direct conversion without dialog
      updateRowWithProduct(rowId, product, 1);
    }
  } else {
    // No currency conversion needed, update row directly
    updateRowWithProduct(rowId, product);
  }
};


// Helper function to update a row with product data
const updateRowWithProduct = (rowId, product, customExchangeRate = null) => {
  setRows((prevRows) =>
    prevRows.map((row) => {
      if (row.id === rowId) {
        let price = product.price || 0;
        const productCurrency = product.currency || systemCurrency;
        
        // Apply exchange rate if needed
        if (productCurrency !== currency && customExchangeRate !== null) {
          price = price * customExchangeRate;
        }
        
        const taxRate = product.tax_rate || 0;
        const quantity = row.quantity || 0;
        const discount_percentage = row.discount_percentage || 0;
        
        const discountPrice = (price * (1 - discount_percentage / 100)).toFixed(2);
        const taxAmount = (parseFloat(discountPrice) * taxRate / 100).toFixed(2);
        const totalPrice = ((parseFloat(discountPrice) + parseFloat(taxAmount)) * quantity).toFixed(2);
        
        return {
          ...row,
          productName: product.name || "",
          productId: product.id || null,
          productCurrency: productCurrency, // Store original currency
          originalPrice: product.price || 0, // Store original price
          price,
          tax: taxRate,
          quantity,
          discount_percentage,
          discountPrice,
          totalPrice,
          convertedCurrency: productCurrency !== currency,
          exchangeRate: customExchangeRate,
        };
      }
      return row;
    })
  );
};

// Handle confirmation of currency conversion
const handleConfirmConversion = (customRate = null) => {
  const { rowId, productId } = currentConversion;
  const product = productList.find(p => p.id === productId);
  
  if (!product) {
    console.error('Product not found for conversion');
    setShowCurrencyConversionDialog(false);
    return;
  }
  
  // Use custom rate if provided, otherwise use the calculated rate
  const rateToUse = customRate !== null ? customRate : currentConversion.exchangeRate;
  
  // Update the row with the converted price
  updateRowWithProduct(rowId, product, rateToUse);
  
  // Show success message
  setSnackbar({
    open: true,
    message: `Converted ${product.name} price from ${currentConversion.sourceCurrency} to ${currentConversion.targetCurrency}`,
    severity: 'success',
  });
  
  // Close the dialog
  setShowCurrencyConversionDialog(false);
};

// Handle cancellation of currency conversion
const handleCancelConversion = () => {
  setShowCurrencyConversionDialog(false);
  // Reset the current row
  const { rowId } = currentConversion;
  setRows(prevRows => 
    prevRows.map(row => 
      row.id === rowId 
        ? {
            ...row,
            productName: "",
            productId: null,
            price: 0,
            tax: 0,
            quantity: 0,
            discount_percentage: 0,
            discountPrice: 0,
            totalPrice: 0,
          }
        : row
    )
  );
};

// Handle custom rate input change
const handleExchangeRateChange = (e) => {
  const newRate = parseFloat(e.target.value);
  if (!isNaN(newRate) && newRate > 0) {
    setCurrentConversion(prev => ({
      ...prev,
      exchangeRate: newRate,
      convertedPrice: prev.originalPrice * newRate
    }));
  }
};




const handleInputChange = (id, field, value) => {
  if (field === "discount_percentage") {
    if (value > 100) {
      value = 100;
    } else if (value < 0) {
      value = 0;
    }
  }
  setRows((prevRows) =>
    prevRows.map((row) => {
      if (row.id === id) {
        const updatedRow = { ...row, [field]: value };

        if (field === "quantity" || field === "discount_percentage") {
          const discountPrice = (
            updatedRow.price * (1 - updatedRow.discount_percentage / 100)
          ).toFixed(2);

          const taxAmount = (parseFloat(discountPrice) * updatedRow.tax / 100).toFixed(2);
          const totalPrice = (
            (parseFloat(discountPrice) + parseFloat(taxAmount)) * updatedRow.quantity
          ).toFixed(2);

          updatedRow.discountPrice = discountPrice;
          updatedRow.totalPrice = totalPrice;
        }

        return updatedRow;
      }
      return row;
    })
  );
};



  useEffect(() => {
    const extractUniqueSuggestions = async () => {
      try {
        const [productsResponse, inventoryResponse] = await Promise.all([
          axiosInstance.get("/products/"),
          axiosInstance.get("/inventory/details/"),
        ]);

        const extractUnique = (arr, field) =>
          [...new Set(arr.map((item) => ({ id: item.id, name: item[field] })))].filter(
            (value) => value.name && value.name.trim() !== ""
          );

        setSuggestions({
          locations: extractUnique(inventoryResponse.data, "location"),
          categories: extractUnique(productsResponse.data, "category"),
          brands: extractUnique(productsResponse.data, "brand"),
          manufacturers: extractUnique(productsResponse.data, "manufacturer"),
          names: extractUnique(productsResponse.data, "name"),
        });

        setProductList(productsResponse.data); // Store the products in productList
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    };

    extractUniqueSuggestions();
  }, []);

  // Calculate subtotal (net), tax on discounted amount, and grand total
  const calculateSummary = () => {
    let subtotal = 0;
    let taxSummary = {};

    rows.forEach((row) => {
      const price = parseFloat(row.price) || 0;
      const quantity = parseFloat(row.quantity) || 0;
      const discountPercentage = parseFloat(row.discount_percentage) || 0;
      const taxRate = parseFloat(row.tax) || 0;
      const discountPrice = parseFloat(row.discountPrice);
      const discountedUnit = Number.isFinite(discountPrice)
        ? discountPrice
        : price * (1 - discountPercentage / 100);
      const itemNet = discountedUnit * quantity;
      subtotal += itemNet;

      if (taxRate) {
        const taxAmount = itemNet * (taxRate / 100);
        taxSummary[taxRate] = (taxSummary[taxRate] || 0) + taxAmount;
      }
    });

    const grandTotal = subtotal + Object.values(taxSummary).reduce((acc, taxAmount) => acc + taxAmount, 0);

    const taxSummaryArray = Object.keys(taxSummary).map(taxRate => ({
      taxRate: parseFloat(taxRate),
      amount: taxSummary[taxRate],
    }));

    return { subtotal, taxSummary: taxSummaryArray, grandTotal };
  };

  const { subtotal: calculatedSubtotal, taxSummary: calculatedTaxSummary, grandTotal: calculatedGrandTotal } = calculateSummary();


  const handleRemoveRow = (id) => {
    // Prevent removal if there's only one row left
    if (rows.length > 1) {
      const updatedRows = rows.filter((row) => row.id !== id);
      setRows(updatedRows);
      onProductsChange(updatedRows);
    } else {
      // Optionally, show a message or alert to inform the user
      setSnackbarMessage("At least one row must remain.");
      setSnackbarOpen(true);
    }
  };

  const handleAddRow = () => {
  setRows([
    ...rows,
    {
      id: uuidv4(),
      productName: "",
      price: 0,
      tax: 0,
      quantity: 0,
      discount_percentage: 0,
      discountPrice: 0,
      totalPrice: 0,
      productCurrency: null, // Add this
      originalPrice: 0, // Add this
      convertedCurrency: false, // Add this
      exchangeRate: 1, // Add this
    },
  ]);
};

  useEffect(() => {
    const fetchCustomFields = async () => {
      try {
        const response = await axiosInstance.get('/custom-fields/quotations');
        setCustomFields(response.data || []);
      } catch (error) {
        setCustomFields([]);
      }
    };
    fetchCustomFields();
  }, []);

  const handleCustomFieldUpdate = (field, value) => {
    setCustomFieldValues(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleCustomFieldError = (field, error) => {
    // Optionally handle errors for custom fields
  };

  const handleDateChange = (e) => {
    const isoDate = e.target.value; // ISO format from date input
    setDeliveryDate(isoDate);
  };

  // Format the date in DD/MM/YYYY format for display
  const formattedDate = "MM/DD/YYYY*";

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="order-modal-title"
        aria-describedby="order-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            maxWidth: '1100px',
            height: '90vh',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box className="pearl-popup-header"
            sx={{
              backgroundColor: colors.popupHeader.background,
              px: 4,
              py: 3,
              position: 'sticky',
              top: 0,
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <MDTypography
              id="order-modal-title"
              variant="h6"
              component="h2"
              sx={{ color: '#FFFFFF' }}
            >
              Add New Order
            </MDTypography>
            <IconButton
              aria-label="Close"
              onClick={onClose}
              sx={{ color: '#FFFFFF', ml: 1 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable content area */}
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              p: 4,
              '&::-webkit-scrollbar': {
                width: '0.4em'
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '4px'
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '4px'
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555'
              }
            }}
          >

            {/* Product Selection Table */}
            <MDBox
              sx={{
                mt: 3,
                mb: 3,
                border: "1px solid #dee2e6",
                borderRadius: "0.75rem",
                overflow: "auto",
                maxHeight: "400px",
              }}
            >
              {/* Header */}
              <MDBox
                sx={{
                  display: "flex",
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #dee2e6",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <MDBox width="20%" p={2}>
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Product Name
                  </MDTypography>
                </MDBox>
                <MDBox width="10%" p={2} textAlign="right">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Unit Price
                  </MDTypography>
                </MDBox>
                <MDBox width="10%" p={2} textAlign="right">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Tax %
                  </MDTypography>
                </MDBox>
                <MDBox width="12%" p={2} textAlign="right">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Discount %
                  </MDTypography>
                </MDBox>
                <MDBox width="12%" p={2} textAlign="right">
                  <MDBox display="flex" justifyContent="flex-end" alignItems="center">
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Discounted Price
                    </MDTypography>
                    <Tooltip title="Discounted Price = (Unit Price - Discount %)" arrow>
                      <IconButton size="small" sx={{ ml: 0.5 }}>
                        <InfoIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <MDBox width="12%" p={2} textAlign="right">
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Quantity
                  </MDTypography>
                </MDBox>
                <MDBox width="12%" p={2} textAlign="right">
                  <MDBox display="flex" justifyContent="flex-end" alignItems="center">
                    <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                      Total Net Price
                    </MDTypography>
                    <Tooltip title="Total Net Price = Discounted Price * Quantity" arrow>
                      <IconButton size="small" sx={{ ml: 0.5 }}>
                        <InfoIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <MDBox width="12%" p={2}>
                  <MDTypography variant="caption" fontWeight="medium" color="text" textTransform="uppercase">
                    Actions
                  </MDTypography>
                </MDBox>
              </MDBox>

              {/* Body */}
              <MDBox>
                {rows.map((row) => (
                  <MDBox
                    key={row.id}
                    display="flex"
                    sx={{
                      borderBottom: "1px solid #dee2e6",
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <MDBox width="20%" p={2}>
                      <Autocomplete
                        options={suggestions.names}
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        onChange={(_, value) => handleProductSelect(row.id, value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Product"
                            size="small"
                            variant="outlined"
                            sx={{
                              width: "90%",
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#dee2e6" },
                                "&:hover fieldset": { borderColor: "#7b809a" },
                              },
                            }}
                          />
                        )}
                        PopperComponent={(props) => (
                          <Popper
                            {...props}
                            sx={{
                              "& .MuiAutocomplete-listbox": {
                                maxHeight: "300px",
                                width: "200px",
                              },
                            }}
                          />
                        )}
                      />

                      {row.convertedCurrency && (
                        <Chip 
                          icon={<CurrencyExchangeIcon />} 
                          label="Converted" 
                          size="small" 
                          color="primary" 
                          sx={{ mt: 0.5 }}
                        />
                      )}
                    </MDBox>
                    <MDBox width="10%" p={2} textAlign="right">
                      <MDTypography variant="button" fontWeight="regular">
                        {formatCurrency(row.price, currency)}
                      </MDTypography>
                      {row.convertedCurrency && (
                        <MDTypography variant="caption" display="block" color="text.secondary">
                          Original: {formatCurrency(row.originalPrice, row.productCurrency)}
                        </MDTypography>
                      )}
                    </MDBox>
                    <MDBox width="10%" p={2} textAlign="right">
                      <MDTypography variant="button" fontWeight="regular">
                        {row.tax}%
                      </MDTypography>
                    </MDBox>
                    <MDBox width="12%" p={2} textAlign="right">
                      <TextField
                        type="number"
                        value={row.discount_percentage}
                        onChange={(e) => handleInputChange(row.id, "discount_percentage", Number(e.target.value))}
                        placeholder="Discount"
                        size="small"
                        sx={{
                          width: "70px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: "#dee2e6" },
                            "&:hover fieldset": { borderColor: "#7b809a" },
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end" sx={{ marginLeft: "-4px", marginRight: "0px" }}>
                              %
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MDBox>
                    {/* Discounted Price cell */}
                    <MDBox width="12%" p={2} textAlign="right">
                      <MDTypography variant="button" fontWeight="regular">
                        {formatCurrency(row.discountPrice, currency)}
                      </MDTypography>
                    </MDBox>
                    <MDBox width="12%" p={2} textAlign="right">
                      <TextField
                        type="number"
                        value={row.quantity}
                        onChange={(e) => handleInputChange(row.id, "quantity", Number(e.target.value))}
                        placeholder="Quantity"
                        size="small"
                        sx={{
                          width: "70px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: "#dee2e6" },
                            "&:hover fieldset": { borderColor: "#7b809a" },
                          },
                        }}
                      />
                    </MDBox>
                    {/* Total Net Price cell */}
                    <MDBox width="12%" p={2} textAlign="right">
                      <MDTypography variant="button" fontWeight="regular">
                        {formatCurrency(row.totalPrice, currency)}
                      </MDTypography>
                    </MDBox>
                    <MDBox width="12%" p={2} display="flex" alignItems="center" justifyContent="center">
                      <IconButton color="error" onClick={() => handleRemoveRow(row.id)} size="small">
                        <RemoveIcon />
                      </IconButton>
                      <IconButton color="info" onClick={handleAddRow} size="small">
                        <AddIcon />
                      </IconButton>
                    </MDBox>
                  </MDBox>
                ))}
              </MDBox>
            </MDBox>

            {/* Totals Section */}
            <MDBox
              sx={{
                mt: 3,
                p: 2,
                borderTop: "2px solid #dee2e6",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <MDBox sx={{ minWidth: "300px" }}>
                {/* In the Totals Section */}
                <MDBox display="flex" justifyContent="space-between" mb={1}>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    Subtotal:
                  </MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="medium">
                    {formatCurrency(calculateSummary().subtotal.toFixed(2), currency)}
                  </MDTypography>
                </MDBox>
                {calculateSummary().taxSummary.map(({ taxRate, amount }) => (
                  <MDBox key={taxRate} display="flex" justifyContent="space-between" mb={1}>
                    <MDTypography variant="button" color="text" fontWeight="regular">
                      Tax ({taxRate}%):
                    </MDTypography>
                    <MDTypography variant="button" color="text" fontWeight="medium">
                      {formatCurrency(amount.toFixed(2), currency)}
                    </MDTypography>
                  </MDBox>
                ))}
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  mt={2}
                  pt={1.5}
                  sx={{ borderTop: "1px solid #dee2e6" }}
                >
                  <MDTypography variant="button" color="dark" fontWeight="medium">
                    Grand Total:
                  </MDTypography>
                  <MDTypography variant="button" color="info" fontWeight="bold">
                    {formatCurrency(calculateSummary().grandTotal.toFixed(2), currency)}
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>
            {/* Summary Section */}
            <Grid container spacing={2} sx={{ marginTop: "10px" }}>

              {/* Autocomplete Section */}
              <Grid container spacing={2} sx={{ margin: "10px" }}>
                <Grid item xs={6}>
                  <Autocomplete
                    options={accountSuggestions}
                    getOptionLabel={(option) => option.name || ""}
                    value={selectedAccount}
                    onChange={(_, newValue) => {
                      setSelectedAccount(newValue);
                      setErrors({ ...errors, account: false });
                    }}
                    defaultValue={preselectedAccount}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Account"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            height: '45px',
                          },
                        }}
                        required
                        error={errors.account}
                        helperText={errors.account ? 'Account is required' : ''}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: errors.account ? 'red' : 'inherit',
                            },
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    options={dealSuggestions}
                    getOptionLabel={(option) => option.name || ""}
                    value={selectedDeal}
                    onChange={(_, newValue) => setSelectedDeal(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Deal"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            height: '45px',
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    options={quotationSuggestions}
                    getOptionLabel={(option) => option.name || ""}
                    value={selectedQuotation}
                    onChange={(_, newValue) => setSelectedQuotation(newValue)}
                    disableClearable
                    disabled
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Quotation"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            height: '45px',
                            backgroundColor: '#f5f5f5', // Light grey background
                            pointerEvents: 'none', // Disables all interactions
                          },
                          readOnly: true, // Prevent keyboard input
                        }}
                      />
                    )}
                  />
                </Grid>


                <Grid item xs={6}>
                  <Autocomplete
                    options={contactSuggestions}
                    getOptionLabel={(option) => option.name || ""}
                    value={selectedContact}
                    onChange={(_, newValue) => {
                      setSelectedContact(newValue);
                      setErrors({ ...errors, contact: false });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Contact"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            height: '45px',
                          },
                        }}
                        required
                        error={errors.contact}
                        helperText={errors.contact ? 'Contact is required' : ''}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: errors.contact ? 'red' : 'inherit',
                            },
                          },
                        }}
                      />
                    )}
                  />
                </Grid>

                {/* <Grid container spacing={2}  sx={{ margin: "10px" }}> */}
                <Grid item xs={6} mt={-1}>
                  <TextField
                    label="Delivery Date"
                    type="date"
                    value={deliveryDate}
                    onChange={(e) => {
                      handleDateChange(e);
                      setErrors((prev) => ({ ...prev, delivery_date: '' }));
                    }}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: toDateOnlyString(new Date()) || undefined,
                    }}
                    error={!!errors.delivery_date}
                    helperText={errors.delivery_date || formattedDate}
                  />
                </Grid>
                <Grid item xs={6} mt={-1}>
                  <TextField
                    label="PO Number"
                    value={poNumber}
                    onChange={(e) => setPoNumber(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={6} mt={-1}>
                  <Autocomplete
                    options={availableCurrencies}
                    getOptionLabel={(option) => option.label}
                    value={availableCurrencies.find(c => c.value === (currency || selectedAccount?.currency || systemCurrency)) || null}
                    onChange={(_, newValue) => setCurrency(newValue ? newValue.value : systemCurrency)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Currency"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            height: '45px',
                          },
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                  />
                </Grid>
                <Grid item xs={6} mt={-3}>
                  <TextField
                    label="Shipping Method"
                    value={shippingMethod}
                    onChange={(e) => setShippingMethod(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={6} mt={-3}>
                  <TextField
                    label="Shipping Address"
                    value={shippingAddress} // Use the combined shippingAddress state
                    onChange={(e) => setShippingAddress(e.target.value)} // Update the combined string
                    fullWidth
                    margin="normal"
                    placeholder="Enter Shipping Address"
                  />
                </Grid>
                <Grid item xs={6} mt={-3}>
                  <TextField
                    label="Billing Address"
                    value={billingAddress}
                    onChange={(e) => setBillingAddress(e.target.value)}
                    fullWidth
                    margin="normal"
                    placeholder="Enter Billing Address"
                  />
                </Grid>

              </Grid>


              {/* Transport Details Section */}
              <Grid item xs={12} margin={1}>
                <MDTypography variant="h6" gutterBottom>
                  Transport Details
                </MDTypography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Transporter ID"
                      value={transid}
                      onChange={(e) => setTransid(e.target.value)}
                      fullWidth
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Transporter Name"
                      value={transname}
                      onChange={(e) => setTransname(e.target.value)}
                      fullWidth
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Transport Mode"
                      value={transmode}
                      onChange={(e) => setTransmode(e.target.value)}
                      fullWidth
                      margin="normal"
                      select
                      InputProps={{
                        // ...params.InputProps,
                        sx: {
                          height: '45px',
                        },
                      }}
                    >
                      <MenuItem value="1">Road</MenuItem>
                      <MenuItem value="2">Rail</MenuItem>
                      <MenuItem value="3">Air</MenuItem>
                      <MenuItem value="4">Ship</MenuItem>
                    </TextField>
                  </Grid>
                  {/* Conditional rendering based on transport mode */}
                  {transmode === '1' && ( // For Road
                    <>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Vehicle Number"
                          value={vehno}
                          onChange={(e) => {
                            setVehno(e.target.value.toUpperCase());
                            setErrors((prev) => ({ ...prev, vehno: '' }));
                          }}
                          fullWidth
                          margin="normal"
                          helperText={errors.vehno || VEHICLE_NUMBER_HELPER}
                          error={!!errors.vehno}
                          inputProps={{
                            pattern: VEHICLE_NUMBER_PATTERN,
                            style: { textTransform: 'uppercase' },
                          }}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Vehicle Type"
                          value={vehtype}
                          onChange={(e) => setvehtype(e.target.value)}
                          fullWidth
                          margin="normal"
                          InputProps={{
                            // ...params.InputProps,
                            sx: {
                              height: '45px',
                            },
                          }}
                          select
                        >
                          <MenuItem value="R">Regular</MenuItem>
                          <MenuItem value="C">Container</MenuItem>
                          <MenuItem value="O">Over Dimensional Cargo</MenuItem>
                        </TextField>
                      </Grid>
                    </>
                  )}
                  {transmode === '2' && ( // For Rail
                    <>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Transport Document Number"
                          value={transdocno}
                          onChange={(e) => setTransdocno(e.target.value)}
                          fullWidth
                          margin="normal"
                        />
                      </Grid>
                    </>
                  )}
                  {transmode === '3' && ( // For Air
                    <>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Transport Document Number"
                          value={transdocno}
                          onChange={(e) => setTransdocno(e.target.value)}
                          fullWidth
                          margin="normal"
                        />
                      </Grid>
                      {/* <Grid item xs={12} md={6}>
                        <TextField
                          label="Transport Document Date"
                          type="date"
                          value={transdocdate}
                          onChange={(e) => setTransdocdate(e.target.value)}
                          fullWidth
                          margin="normal"
                        />
                      </Grid> */}
                    </>
                  )}
                  {transmode === '4' && ( // For Ship
                    <>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Vehicle Number"
                          value={vehno}
                          onChange={(e) => {
                            setVehno(e.target.value.toUpperCase());
                            setErrors((prev) => ({ ...prev, vehno: '' }));
                          }}
                          fullWidth
                          margin="normal"
                          helperText={errors.vehno || VEHICLE_NUMBER_HELPER}
                          error={!!errors.vehno}
                          inputProps={{
                            pattern: VEHICLE_NUMBER_PATTERN,
                            style: { textTransform: 'uppercase' },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Transport Document Number"
                          value={transdocno}
                          onChange={(e) => setTransdocno(e.target.value)}
                          fullWidth
                          margin="normal"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} margin={1} sx={{ mt: -1 }}>
                <TextField
                  label="Notes"
                  value={shippingInstruction}
                  onChange={(e) => setShippingInstruction(e.target.value)}
                  fullWidth
                  multiline
                  rows={4}
                />
              </Grid>
            </Grid>

            {/* Custom Fields Section */}
            {customFields && customFields.length > 0 && (
              <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item xs={12}>
                  <MDBox mt={2}>
                    <MDTypography variant="h6" gutterBottom>
                      Custom Fields
                    </MDTypography>
                    <CustomFieldsSection
                      ref={customFieldsRef}
                      objectType="orders"
                      objectData={customFieldValues}
                      isEditing={true}
                      onFieldUpdate={handleCustomFieldUpdate}
                      onError={handleCustomFieldError}
                      formErrors={{}}
                    />
                  </MDBox>
                </Grid>
              </Grid>
            )}
          </Box>

          {/* Footer Actions */}
          <Box
            sx={{
              borderTop: '1px solid #eee',
              p: 2,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 2,
            }}
          >
            <MDButton
              onClick={handleCancel}
              color="secondary"
            >
              Cancel
            </MDButton>
            <MDButton
              onClick={handleSaveOrder}
              variant="gradient"
              color="info"
              // sx={{ mr: 2 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Save'}
            </MDButton>

          </Box>
        </Box>
      </Modal>

      {/* Confirmation Dialog */}
      <Dialog
        open={openConfirmationDialog}
        onClose={handleDialogClose}
      >
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <MDTypography variant="body2">
            Do you really want to close without saving?
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={handleDialogClose}
            color="secondary"
          >
            No
          </MDButton>
          <MDButton
            onClick={handleConfirmCancel}
            color="primary"
          >
            Yes
          </MDButton>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Changed position
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>


      {/* Currency Conversion Dialog */}
      <Dialog
        open={showCurrencyConversionDialog}
        onClose={handleCancelConversion}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
          }
        }}
      >
        {/* Dialog Header */}
        <Box className="pearl-popup-header"
          sx={{
            backgroundColor: colors.popupHeader.background,
            px: 3,
            py: 2.5,
          }}
        >
          <MDTypography
            variant="h6"
            component="h2"
            sx={{ color: '#FFFFFF' }}
          >
            <CurrencyExchangeIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Currency Conversion Required
          </MDTypography>
        </Box>

        {/* Dialog Content */}
        <DialogContent sx={{ p: 3, mt: 1 }}>
          {isLoadingRates ? (
            <Box display="flex" justifyContent="center" alignItems="center" p={3}>
              <CircularProgress />
              <Typography variant="body1" sx={{ ml: 2 }}>
                Fetching latest exchange rates...
              </Typography>
            </Box>
          ) : (
            <>
              <Typography variant="body1" gutterBottom>
                The selected product <strong>{currentConversion.productName}</strong> is priced in <strong>{currentConversion.sourceCurrency}</strong> but your order is in <strong>{currentConversion.targetCurrency}</strong>.
              </Typography>
              
              <Box sx={{ my: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="text.secondary">Original Price:</Typography>
                    <Typography variant="h6">
                      {formatCurrency(currentConversion.originalPrice, currentConversion.sourceCurrency)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="text.secondary">Converted Price:</Typography>
                    <Typography variant="h6" color="primary">
                      {formatCurrency(currentConversion.convertedPrice, currentConversion.targetCurrency)}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Typography variant="body2" gutterBottom>
                Current exchange rate: 1 {currentConversion.sourceCurrency} = {currentConversion.exchangeRate.toFixed(4)} {currentConversion.targetCurrency}
              </Typography>
              
              <TextField
                fullWidth
                label="Custom Exchange Rate (Optional)"
                type="number"
                InputProps={{
                  inputProps: { min: 0.0001, step: 0.0001 }
                }}
                value={currentConversion.exchangeRate}
                onChange={handleExchangeRateChange}
                helperText="You can adjust the exchange rate if needed"
                margin="normal"
              />
            </>
          )}
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <MDButton
            onClick={handleCancelConversion}
            variant="outlined"
            color="secondary"
            disabled={isLoadingRates}
          >
            Cancel
          </MDButton>
          <MDButton
            onClick={() => handleConfirmConversion(currentConversion.exchangeRate)}
            variant="gradient"
            color="info"
            disabled={isLoadingRates}
          >
            Apply Conversion
          </MDButton>
        </DialogActions>
      </Dialog>

    </>
  );
}

export default OrderModal;